/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddPreseasonGameDateProposalDto } from '../models/AddPreseasonGameDateProposalDto';
import type { PreseasonGameDateProposalDto } from '../models/PreseasonGameDateProposalDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PreseasonGameDateProposalControllerService {
    /**
     * @param requestBody
     * @returns PreseasonGameDateProposalDto Created
     * @throws ApiError
     */
    public static addPreseasonGameDateProposal(
        requestBody: AddPreseasonGameDateProposalDto,
    ): CancelablePromise<PreseasonGameDateProposalDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/preseason-game-date-proposals',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
